export default __webpack_public_path__ + "static/media/shopping-basket.ccf71aaf.svg";